import { defineComponent, computed } from '@vue/composition-api';
import { useBrandImage } from './useBrandImage.js';
import __vue_component__ from '../content/CustomImage.vue.js';

var script = defineComponent({
    name: 'SdsBrandImage',
    props: {
        name: {
            type: String,
            required: true,
        },
        alt: {
            type: String,
            required: false,
            default: '', // Means presentational for alt
        },
        size: {
            type: [String, Number],
            default: '',
        },
    },
    setup: function (props) {
        var imageSize = computed(function () {
            if (typeof props.size === 'number') {
                return "".concat(props.size, "px");
            }
            switch (props.size) {
                case 'xs':
                    return 'var(--size-illustration-xs)';
                case 'sm':
                    return 'var(--size-illustration-sm)';
                case 'md':
                    return 'var(--size-illustration-md)';
                default:
                    return undefined;
            }
        });
        return {
            // Do not use a suffix, the custom image will handle it
            src: computed(function () { return useBrandImage(props.name, '1', ''); }),
            imageSize: imageSize,
        };
    },
    components: {
        CustomImage: __vue_component__,
    },
});

export default script;
